import React from 'react';

export default () => (
    <div className={'container'}><h2>Contact us </h2>
        <p>We'd love your feedback on Ovalview. </p>
        <p>Feel free to drop us a line at <a href={`mailto:contact@ovalview.io`}>contact@ovalview.io</a> </p>
    </div>
);
